import reduceReducers from "reduce-reducers"
import { get } from "lodash"

import ActionTypes from "../../enums/ActionTypes"
import { createPlanningObjectsReducer } from "../planningObjects"

function updateReducer(state = { errorCode: null }, action) {
  const { payload } = action
  switch (action.type) {
    case ActionTypes.PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE_FAILURE:
      return {
        ...state,
        error: get(payload, "response.errorCode"),
        errorCode: get(payload, "response.errorCode"),
        detailsObject: get(payload, "response.detailsObject"),
        isUpdatePending: false,
      }

    case ActionTypes.PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_LOAD_REQUEST:
    case ActionTypes.PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE_REQUEST:
      return {
        ...state,
        error: null,
        errorCode: null,
        isUpdatePending: true,
      }

    case ActionTypes.PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_LOAD_SUCCESS:
    case ActionTypes.PLANNING_OBJECTS_PRODUCTION_ORDER_DETAILS_UPDATE_SUCCESS:
      return {
        ...state,
        isUpdatePending: false,
      }
    default:
      return state
  }
}

export default reduceReducers(createPlanningObjectsReducer("productionOrders"), updateReducer)
